import mapKeys from 'lodash/mapKeys';

export default (payload, selector = 'id') => {
    const results = mapKeys(payload, selector);
    const allIds = Object.keys(results);

    return { results, allIds };
};
